<template>
  <v-card class="audit" flat>
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>
    <div class="table">
      <v-row class="table-header" no-gutters>
        <v-col>姓名</v-col>
        <v-col>年齡</v-col>
        <v-col>建立時間</v-col>
        <v-col style="min-width: 192px; max-width: 192px"></v-col>
        <v-col style="min-width: 192px; max-width: 192px"></v-col>
        <v-col v-if="tab == 1">原因</v-col>
        <v-col style="min-width: 100px; max-width: 100px"></v-col>
      </v-row>
      <div class="table-body">
        <template v-for="record in auditList">
          <v-row class="table-content" no-gutters :key="record.id">
            <v-col>{{ record.last_name }}{{ record.first_name }}</v-col>
            <v-col>{{ record.age }}</v-col>
            <v-col>{{ record.created_at | formatDate }}</v-col>
            <v-img 
              v-for="src in [record.frontSrc, record.backSrc]"
              :key="src"
              class="pointer mx-4" 
              :src="src" 
              aspect-ratio="1.6"  
              max-height="150" 
              max-width="160" 
              min-height="100" 
              min-width="160" 
              @click="overlay = {active: true, src: src}"
            ></v-img>
            <v-col v-if="tab == 1">{{ record.reason }}</v-col>
            <v-col style="min-width: 100px; max-width: 100px">
              <v-btn icon small  v-if="tab == 0">
                <v-icon 
                  small 
                  color="red"
                  @click="$refs.reasonDialog.submit(reason => identity(record, false, reason))"
                >
                 fa-times
               </v-icon>
              </v-btn>
              <v-btn icon small>
                <v-icon small color="success" @click="identity(record, true)">fa-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </div>
    </div>

    <ReasonDialog ref="reasonDialog"></ReasonDialog>
    
    <v-overlay z-index="99" opacity=".8" :value="overlay.active" @click.native="overlay.active = false">
      <v-img :src="overlay.src" aspect-ratio="1.6" width="600"></v-img>
    </v-overlay>
    

  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
import ReasonDialog from '@/components/ReasonDialog'
export default {
  components: { AdminToolbar, ReasonDialog },
  data() {
    return {
      overlay: {active: false},
      searchTypes: [],
      sortTypes: [
        { text: '建立日期', table: 'carts', column: 'checkout_time', by: 'desc' },
      ],
      tabs: [
        {text: '待審核', value: 'unauthenticate'},
        {text: '已拒絕', value: 'denied'},
      ],
      tab: 0,
      sort: '',
      search_condition: [],
      auditList: [],
    }
  },
  created() {
    this.getAuditList()
  },
  methods: {
    searching() {
      this.getAuditList()
    },
    getAuditList() {
      let origin = this.tab
      this.axios.get('/admin/identity').then(response => {
        if(origin != this.tab) {
          return
        }
        if(this.tab == 0) {
          this.auditList = response.data.filter(record => !record.denied)
        }
        else {
          this.auditList = response.data.filter(record => record.denied)
        }
        this.auditList.forEach((record, i) => {
          let frontSrc = '/admin' + record.front_image_path.substring(4)
          this.$func.urlToBase64(frontSrc).then(result => {
            this.$set(this.auditList[i], 'frontSrc', result)
          })
          let backSrc = '/admin' + record.back_image_path.substring(4)
          this.$func.urlToBase64(backSrc).then(result => {
            this.$set(this.auditList[i], 'backSrc', result)
          })
        })
      })
    },
    identity(record, action, reason='') {
      this.axios.put(`/admin/identity/${record.id}`, {
        'verify' : action,
        'reason' : reason
      }).then(response => {
        this.dialog = false
        this.auditList.splice(this.auditList.indexOf(record), 1)
        this.$root.$emit('alert', 'success', '成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.audit {
  .v-overlay__content {
    max-width: 100%;
  }
}
</style>